import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.number.constructor.js";
import React from 'react';
import { useMatch } from 'react-router-dom';
import { Provider as AssetViewerContextProvider } from 'screens/AssetViewerUI/hooks/useAssetViewerContext';
import useAssetViewerQueryParams from 'screens/AssetViewerUI/hooks/useAssetViewerQueryParams';
import HubAssetViewer from './HubAssetViewer';
import { jsx as _jsx } from "react/jsx-runtime";
function AssetViewerFromQuery() {
  var _useAssetViewerQueryP = useAssetViewerQueryParams('asset'),
    _useAssetViewerQueryP2 = _slicedToArray(_useAssetViewerQueryP, 2),
    params = _useAssetViewerQueryP2[0],
    removeParams = _useAssetViewerQueryP2[1];

  // Using useMatch in place of useParams as the context provider is outside the Route path scope
  var path = useMatch('/playlists/:id');
  var _ref = (path === null || path === void 0 ? void 0 : path.params) || {},
    playlistId = _ref.id;
  var parentPlaylistId = params.playlistId || playlistId && Number(playlistId) || null;
  if (!(params !== null && params !== void 0 && params.assetId)) {
    return null;
  }
  return /*#__PURE__*/_jsx(AssetViewerContextProvider, {
    assetId: params.assetId,
    playlistId: parentPlaylistId,
    isPublished: params.isPublished,
    children: /*#__PURE__*/_jsx(HubAssetViewer, {
      onClose: removeParams
    })
  });
}
export default AssetViewerFromQuery;